import { CategoryLevel1_CODE, CategoryLevel2_CODE, CategoryLevel2ToLevel1Map, ICategory } from './types';

/**
 * ICategory 데이터를 MpsCategory 엔티티로 래핑
 */
export interface MpsCategory {
  getRootCode(): string;
  getRootId(): number;
  getRootName(): string;
  getId(): number;
  getCode(): string;
  getName(): string | null;
  getRankName(): string;
  getLevel(): number;
  getImageUrl(): string | null;
  getChildren(): MpsCategory[];
  toData(): ICategory;
  isCloth(): boolean;
  isGoods(): boolean;
  isHandmade(): boolean;
  isBrandDeal(): boolean;
  isEbook(): boolean;
}

export class MpsCategoryImpl implements MpsCategory {
  constructor(private data: ICategory) {}

  getRootCode(): string {
    return this.data.root_code;
  }

  getRootId(): number {
    return this.data.root_id;
  }

  getRootName(): string {
    return ET(`mps2::common::category::level_1::${this.data.root_code.toLocaleLowerCase()}`);
  }

  getId(): number {
    return this.data.id;
  }

  getCode(): string {
    return this.data.code;
  }

  getName(): string | null {
    switch (ET.lang) {
      case 'en':
        return this.data.name_en || this.data.name;
      case 'jp':
        return this.data.name_jp || this.data.name;
      default:
        return this.data.name;
    }
  }

  getRankName(): string {
    return (
      {
        [CategoryLevel1_CODE.GOODS]: ET('mps2::ranking::cate_roots::goods'),
        [CategoryLevel1_CODE.HANDMADE]: ET('mps2::ranking::cate_roots::handmade'),
        [CategoryLevel1_CODE.BRAND_DEAL]: ET('mps2::ranking::cate_roots::brand_deal'),
        [CategoryLevel1_CODE.EBOOK]: ET('mps2::ranking::cate_roots::ebook'),
      }[this.data.code] || ''
    );
  }

  getLevel(): number {
    return this.data.level;
  }

  getImageUrl(): string | null {
    return (
      CategoryLevel2ToLevel1Map[this.data.code as CategoryLevel2_CODE]?.[this.data.root_code]?.image || null
    );
  }

  getChildren(): MpsCategory[] {
    return this.data.children.map(createMpsCategoryAccessor);
  }

  toData(): ICategory {
    const deepCopy = (category: ICategory): ICategory => ({
      ...category,
      children: category.children.map(deepCopy),
    });

    return deepCopy(this.data);
  }

  isGoods(): boolean {
    return this.data.root_code === CategoryLevel1_CODE.GOODS;
  }

  isHandmade(): boolean {
    return this.data.root_code === CategoryLevel1_CODE.HANDMADE;
  }

  isCloth(): boolean {
    return this.data.is_cloth ?? false;
  }

  isBrandDeal(): boolean {
    return this.data.root_code === CategoryLevel1_CODE.BRAND_DEAL;
  }

  isEbook(): boolean {
    return false;
  }
}

export const createMpsCategoryAccessor = (data: ICategory): MpsCategory => {
  return new MpsCategoryImpl(data);
};
